// @flow
import React from 'react';
import universal from 'react-universal-component';
import { AppStateProvider } from "@core-ui/app-state-provider";
import { SitewideContextProvider } from "@mfe/sitewide";
import { BreakpointProvider } from '@core-ui/breakpoint-provider';
import { I18nProvider } from '@core-ui/i18n';
import BrandInfoProvider from '@core-ui/brand-info-provider';
import { CertonaProvider } from '@core-ui/certona-provider';
import { LocalizationProvider } from '@core-ui/localization-provider';
import MarketingComponent from '@core-ui/marketing-ui';
import MarketingProvider from '@core-ui/marketing-provider';
import { PersonalizationProvider } from '@core-ui/personalization-provider';
import { StitchStyleProvider } from '@core-ui/react-stitch';
import { Provider as FeatureFlagProvider } from '@core-ui/feature-flags';
import CategoryPage from './components/category-page';

import With3rdParties from './with3rdParties';

// this is a carryover from the catagory-page-old repo, delete if not useful
const Style = universal(
  ({ abbrBrand }) => import(`./style-entry/${`${abbrBrand}-category`}`),
  {
    loading: () => null,
    ignoreBabelRename: true,
  }
);

type Props = {
  abbrBrand: string,
  abbrNameForTealium: string,
  brand: string,
  criticalResources: CriticalResources,
  dataLayer: DataLayer,
  enabledFeatures: { [key: string]: boolean },
  errorLogger: ?string => void,
  featureVariables: { [key: string]: string },
  initialSizeClass: string,
  locale: Locale,
  pageType: string,
  marketAgnosticBrandCode: number,
  translations: TranslationData,
  highPriorityEvents: Array<any>, // TODO
  params: { cid: string, style: any }, // TODO style not required?
  breadcrumbs: any, // TODO
  contentData: any, // TODO
  webHierarchy: any, // TODO
  selectedNodes: SelectedNodes,
  abSeg: any, // TODO
  market: any, // TODO
  categoryName: string,
  leftNav: LeftNavType,
  datalayer: any, // TODO
  criticalCss: any, // TODO
  brandName: any, // TODO
  businessUnitId: any, // TODO
  locationConfig: any, // TODO
  productsUrl: string,
  productsApikey: string,
  showPreviewBar: any, // TODO
  webHierarchy: any, // TODO
  smartCrosslinks: { crosslinks: Array<?{ [key: string]: string }>, globalVariables: { [key: string]: string } },
};

export const errorLogger = (props: any, error: any) => {
  props.errorLogger(error);

  throw error;
};

const App = (props: Props) => (
  <AppStateProvider value={{ ...props, brandName: props.abbrBrand }}>
     <SitewideContextProvider>
      <FeatureFlagProvider
      value={{
        enabledFeatures: props.enabledFeatures,
        featureVariables: props.featureVariables,
      }}
    >
      <BreakpointProvider initialSizeClass={props.initialSizeClass || 'Mobile'}>
        <I18nProvider locale={props.locale}
            translations={props.translations}>
          <LocalizationProvider
            locale={props.locale}
            translations={props.translations}
          >
            <PersonalizationProvider
              datalayer={props.datalayer}
              errorLogger={err => errorLogger(props, err)}
              marketAgnosticBrandCode={props.marketAgnosticBrandCode}
            >
              <BrandInfoProvider {...props}>
                <StitchStyleProvider brand={props.brand}>
                  <Style abbrBrand={props.abbrBrand} />
                  <With3rdParties {...props}>
                    <CertonaProvider
                      errorLogger={() => {}}
                      pageType={props.pageType}
                    >
                      <MarketingProvider
                        {...props}
                        MarketingComponent={MarketingComponent}
                      >
                        <CategoryPage {...props} />
                      </MarketingProvider>
                    </CertonaProvider>
                  </With3rdParties>
                </StitchStyleProvider>
              </BrandInfoProvider>
            </PersonalizationProvider>
          </LocalizationProvider>
        </I18nProvider>
      </BreakpointProvider>
    </FeatureFlagProvider>
    </SitewideContextProvider>
  </AppStateProvider>
);

export { App };
